class UrlHandler {
    constructor() {
        this.urlArr = [];

        this.init();

        window.pubSubEvents.subscribe('hubsUpdate', (params) => {
            if(params && params.length > 0) {
                const dataAsQueryString = this.parseData(params).filter((value, index, self) => {
                    return self.indexOf(value) === index;
                  });
                    window.history.pushState(
                        null,
                        'contentHubsStateTitle',
                        window.location.pathname.trim('/') + '?' + dataAsQueryString.join('&'));
                } else {
                    window.history.pushState(null, 'contentHubsStateTitle', window.location.pathname.trim('/'));
                }
        });
    }

    init() {
        if (window.location.search > '') {
            const urlParams = location.search.substring(1).split('&').map((str) => {
                const tmp = str.split('=');
                if (tmp.length > 1) {
                    return {
                        param: tmp[0],
                        values: tmp[1].split(/[, ]+/)
                    };
                }
            });

          urlParams.forEach(param => setTimeout(function() { window.pubSubEvents.publish('urlUpdate', param); }, 600));
        }
    }

     parseData(data) {
        const result = [];
        const searchFields = [];
        let searchValue = '';

        data.forEach(el => {
                if (el.hasOwnProperty('fieldName')) {
                    if (el.fieldName != 'search-value-with-fields') {
                        searchFields.push(encodeURI(el.fieldName));
                    }
                    searchValue = encodeURI(el.value);
                }
                else {
                    result.push(el.taxonName + '=' + el.value.join())
                }
            });

        if (searchValue) {
            result.push('search-value-with-fields' + '=' + searchValue + "," + searchFields.join());
        }
        return result;
    }
}

export default UrlHandler;
